import React from 'react';
import { AsyncStorage } from 'react-native';

export default class PromotionCodesStorage {
  setPromotionCodes(promotionCodes, memberId) {
    AsyncStorage.setItem(
      'PROMOTION_CODES',
      JSON.stringify({
        promotionCodes: promotionCodes,
        memberId: memberId,
      })
    );
  }

  getPromotionCodes(callback) {
    AsyncStorage.getItem('PROMOTION_CODES', (error, result) => {
      if (!error && result) {
        try {
          const promotionCodes = JSON.parse(result);
          callback(promotionCodes);
        } catch (error) {
          console.log('Failed to parse PROMOTION_CODES, skipping it', error);
        }
      }
    });
  }
}

export const promotionCodesStorage = new PromotionCodesStorage();
